module.exports = __webpack_public_path__ + "34dd8b69c97d75434ffe346449f9f9ad.pdf";